import React, { useState } from "react";
import { Button, Col } from "reactstrap";
import { useTranslation } from "react-i18next";
import { FaFilePdf, FaRegImage } from "react-icons/fa";
import Required from "../validate/Required";
import ViewImgAndPdf from "../modals/ViewImgAndPdf";
import { ValidateImgPdf } from "../../utils/Utils";

const ImageUpload = ({
  watch,
  register,
  profile,
  handleImageChange,
  errors,
  setValue,
  setError,
  clearErrors,
  handleImageOpenPreview,
  label,
  image,
  image_url,
  design,
  required,
  validateDoc,
}) => {
  const { t } = useTranslation();
  const [modalImages, setModalImages] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [titleName, setTitleName] = useState("");
  const [fileTypePreview, setFileTypePreview] = useState("");
  const handleRemoveImage = (errorInput, url) => {
    setValue(errorInput, "");
    setValue(url, null);
    setValue(`${image}_type`, ""); // Clear MIME type too
    const fileInput = document.getElementById(errorInput);
    if (fileInput) {
      fileInput.value = null;
    }
  };

  const handleFileValidation = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (validateDoc) {
      ValidateImgPdf(file, (isValid) => {
        if (!isValid) {
          setError(image, {
            type: "manual",
            message: t("Only PNG, JPEG or PDF files are allowed"),
          });
          e.target.value = null;
          setValue(image, "");
        } else {
          clearErrors(image);
          setValue(`${image}_type`, file.type); // Store MIME type
          handleImageChange(e, image, image_url);
        }
      });
    } else {
      setValue(`${image}_type`, file.type); // Store MIME type
      handleImageChange(e, image, image_url);
    }
  };
  const toggleImageModal = () => {
    setModalOpen(true);
  };
  const toggleModal = () => {
    setModalOpen((prev) => !prev);
  };
  const handleImageClick = (index, image, inputName, fileType) => {
    setCurrentImageIndex(index);
    // Replace label with "Document 1" for keys like document_0_img
    const displayTitle = /^document_\d+_img$/.test(inputName)
      ? `Document ${parseInt(inputName.match(/\d+/)?.[0] || "0", 10) + 1}`
      : inputName;

    setTitleName(displayTitle);
    setFileTypePreview(fileType);

    if (fileType === "application/pdf") {
      if (image instanceof File || image instanceof Blob) {
        setModalImages([URL.createObjectURL(image)]);
      } else {
        // if it's a string or already a URL
        setModalImages([image]);
      }
    } else {
      setModalImages([image]);
    }

    toggleModal();
  };

  const ColProps = design === false ? {} : { md: "3", sm: "3", xxl: "3" };

  const fileType = watch(`${image}_type`);

  const isPdfFile = fileType === "application/pdf";

  return (
    <>
      <Col {...ColProps}>
        <div className="form-group">
          {label && (
            <label className="form-label" htmlFor={image}>
              {t(label)} {required && <Required />}
            </label>
          )}
          {(watch(image_url) === null || errors?.[image]) && (
            <input
              type="file"
              accept="image/*,application/pdf"
              className={`form-control ${errors?.[image] ? "is-invalid" : ""}`}
              id={image}
              {...register(image, {
                required: required
                  ? {
                      value: true,
                      message: t(
                        label ? `${label} is required` : "Image is required"
                      ),
                    }
                  : false,
              })}
              onChange={handleFileValidation}
              placeholder={t("Upload")}
            />
          )}
          {errors?.[image] && (
            <span className="invalid">{t(errors[image]?.message)}</span>
          )}
        </div>

        <div className="col-md-3">
          {watch(image_url) && !profile && (
            <>
              <span
                className="mx-2"
                onClick={() => handleRemoveImage(image, image_url)}
                style={{ cursor: "pointer" }}
              >
                x
              </span>

              {isPdfFile ? (
                <Button
                  outline
                  id="img"
                  color="danger"
                  type="button"
                  onClick={() =>
                    handleImageClick(0, watch(image), label || image, fileType)
                  }
                  size="xxl"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="View PDF"
                >
                  <FaFilePdf style={{ height: "1rem", width: "1rem" }} />
                </Button>
              ) : (
                <img
                  src={watch(image_url)}
                  alt={image}
                  style={{
                    maxWidth: "80px",
                    maxHeight: "80px",
                    marginLeft: "20px",
                    objectFit: "cover",
                  }}
                  onClick={() =>
                    handleImageClick(
                      0,
                      watch(image_url),
                      label || image,
                      fileType
                    )
                  }
                />
              )}
            </>
          )}
        </div>
      </Col>

      <ViewImgAndPdf
        fileType={fileTypePreview}
        titleName={titleName}
        isOpen={modalOpen}
        toggleModal={toggleModal}
        images={modalImages}
        currentImageIndex={currentImageIndex}
        setCurrentImageIndex={setCurrentImageIndex}
        docUploadView={true}
      />
    </>
  );
};

export default ImageUpload;
